import $ from 'jquery';

const defaults = {
  title: '.title',
};

function StringSplit(element, options) {
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.title = this.settings.title;
  this.init();
  this.ready();
}

StringSplit.prototype = {
  init() {
    // hack in differences in font size when a BR tag is present
    $(this.title, this.element).each((i, title) => {
      const html = $(title).html();
      if (/<br>/.test(html)) {
        const a = html.split('<br>');
        $(title).addClass('splitText').html(`<span>${a[0]}</span>${a[1]}`);
      }
    });
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default StringSplit;



// WEBPACK FOOTER //
// ./StringSplit.js